import { Controller, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { Label } from "components/ui/label";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "components/ui/select";
import type { IConfigParamsFormValues } from "features/chat/agent-chat-module/services/gpt-chat.service";

import { MCP_AUTH_TYPE_OPTIONS, MCP_STATIC_AUTH_DEFAULTS } from "./config-params-modal-utils";

export function ConfigParamsAuthTypeSelect() {
  const { t } = useTranslation();
  const { control, setValue } = useFormContext<IConfigParamsFormValues>();

  return (
    <Controller
      name="authType"
      control={control}
      render={({ field }) => (
        <div className="flex flex-col gap-2">
          <Label htmlFor="authType" className="mb-2">
            {t("AUTHENTICATION_TYPE", "Authentication Type")}
          </Label>
          <Select
            value={field.value}
            onValueChange={(value) => {
              field.onChange(value);
              const defaults = MCP_STATIC_AUTH_DEFAULTS[value as IConfigParamsFormValues["authType"]];
              if (defaults) {
                setValue("authKeyName", defaults.authKeyName);
                setValue("authKeyPrefix", defaults.authKeyPrefix);
              }
            }}
          >
            <SelectTrigger id="authType" className="w-full sm:w-1/2">
              <SelectValue
                placeholder={t("SELECT_AUTHENTICATION_TYPE", "Select authentication type")}
              />
            </SelectTrigger>
            <SelectContent position="popper" sideOffset={4}>
              {MCP_AUTH_TYPE_OPTIONS.map((option) => (
                <SelectItem key={option.value} value={option.value}>
                  {t(option.labelKey, option.defaultLabel)}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>
      )}
    />
  );
}
